import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { fetchSecurityQuestions, storeSecurityQuestions, updateProfile, getGoogleMapsApiKey } from "../../services/api";
import startnow from "../../images/two-policeman-with-security-lock-and-a-notebook-in(1).png";
import { Navigate, useNavigate } from "react-router-dom";


const Securityquestion=()=>{
	const [securityquestions, setSecurityQuestions]= useState([]);
	const [errors, setErrors] = useState([]);
	const [currentStep, setCurrentStep] = useState(1);
	const [profileData, setProfileData] = useState({
		first_name: '',
		last_name: '',
		address: ''
	});
	const [profileErrors, setProfileErrors] = useState({});
	const [isLoading, setIsLoading] = useState(false);
	const [isSubmittingQuestions, setIsSubmittingQuestions] = useState(false);
	const [googleMapsApiKey, setGoogleMapsApiKey] = useState('');
	const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
	const addressInputRef = useRef(null);
	const autocompleteRef = useRef(null);

	const navigate = useNavigate();
	const [questions, setQuestions] = useState([
		{ question: "", answer: "" },
		{ question: "", answer: "" },
		{ question: "", answer: "" }
	  ]);
	const [acknowledged, setAcknowledged] = useState(false);
	  const getquestions=async()=>{
		const token = sessionStorage.getItem('token');
		const response = await fetchSecurityQuestions(token);
		setSecurityQuestions(response.data.questions);
  		}

	  // Profile handling functions
	  const handleProfileChange = (e) => {
		const { name, value } = e.target;
		setProfileData({
		  ...profileData,
		  [name]: value
		});
		// Clear error when user starts typing
		if (profileErrors[name]) {
		  setProfileErrors({
			...profileErrors,
			[name]: ''
		  });
		}
	  };

	  const validateProfile = () => {
		let errors = {};

		if (!profileData.first_name.trim()) {
		  errors.first_name = 'First name is required';
		}
		if (!profileData.last_name.trim()) {
		  errors.last_name = 'Last name is required';
		}
		if (!profileData.address.trim()) {
		  errors.address = 'Address is required';
		}

		setProfileErrors(errors);
		return Object.keys(errors).length === 0;
	  };

	  const handleProfileSubmit = async (e) => {
		e.preventDefault();
		
		if (validateProfile()) {
		  setIsLoading(true);
		  
		  try {
			const token = sessionStorage.getItem("token");
			const userId = sessionStorage.getItem("user_id");
			
			const formDataToSend = new FormData();
			formDataToSend.append("first_name", profileData.first_name);
			formDataToSend.append("last_name", profileData.last_name);
			formDataToSend.append("address", profileData.address);
			formDataToSend.append("user_id", userId);

			const response = await updateProfile(token, formDataToSend);
			
			if (response.data) {
			  // Profile updated successfully, move to next step
			  sessionStorage.setItem("user_name", profileData.first_name);
			  setCurrentStep(2);
			}
		  } catch (error) {
			console.error('Error updating profile:', error);
			if (error.response && error.response.status === 422) {
			  const serverErrors = error.response.data.errors;
			  setProfileErrors({
				...serverErrors,
			  });
			} else {
			  setProfileErrors({ general: 'An error occurred. Please try again.' });
			}
		  } finally {
			setIsLoading(false);
		  }
		}
	  };

	  useEffect(()=>{
		if(sessionStorage.getItem('securityCheck') === '1')
		{
			navigate("/course/home")
		}
		sessionStorage.setItem('topicStatus','1');
		getquestions();
		loadGoogleMapsApiKey();
		
		// Check if profile is already completed
		const userName = sessionStorage.getItem('user_name');
		if (userName && userName.trim() !== 'null') {
			// Profile is already completed, go directly to step 2
			setCurrentStep(2);
		} else {
			// Try to populate form with existing data if available
			const user = JSON.parse(sessionStorage.getItem('user') || '{}');
			if (user.first_name || user.last_name || user.address) {
				setProfileData({
					first_name: user.first_name || '',
					last_name: user.last_name || '',
					address: user.address || ''
				});
			}
		}
	  },[]);

	  useEffect(() => {
		if (googleMapsApiKey && !isGoogleMapsLoaded) {
		  loadGoogleMapsScript();
		}
	  }, [googleMapsApiKey, isGoogleMapsLoaded]);

	  useEffect(() => {
		if (isGoogleMapsLoaded && addressInputRef.current && !autocompleteRef.current) {
		  setTimeout(() => {
			initializeAutocomplete();
		  }, 100);
		}
	  }, [isGoogleMapsLoaded]);

	  // Cleanup autocomplete on unmount
	  useEffect(() => {
		return () => {
		  if (autocompleteRef.current) {
			window.google?.maps?.event?.clearInstanceListeners(autocompleteRef.current);
			autocompleteRef.current = null;
		  }
		};
	  }, []);

	  const loadGoogleMapsApiKey = async () => {
		try {
		  const response = await getGoogleMapsApiKey();
		  
		  if (response.data) {
		
			setGoogleMapsApiKey(response.data.data);
		  } else {
			// Fallback to environment variable if backend doesn't have the key
			const fallbackKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
			if (fallbackKey) {
			  setGoogleMapsApiKey(fallbackKey);
			}
		  }
		} catch (error) {
		  // Fallback to environment variable if backend endpoint doesn't exist
		  const fallbackKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
		  if (fallbackKey) {
			setGoogleMapsApiKey(fallbackKey);
		  }
		}
	  };

	  const loadGoogleMapsScript = () => {
		if (window.google && window.google.maps && window.google.maps.places) {
		  setIsGoogleMapsLoaded(true);
		  return;
		}

		if (!googleMapsApiKey) {
		  return;
		}

		// Remove any existing Google Maps script
		const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
		if (existingScript) {
		  existingScript.remove();
		}

		const script = document.createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places`;
		script.async = true;
		script.defer = true;
		script.onload = () => {
		  setIsGoogleMapsLoaded(true);
		};
		script.onerror = () => {
		  // Silent error handling
		};
		document.head.appendChild(script);
	  };

	  const initializeAutocomplete = () => {
		if (!window.google || !window.google.maps || !window.google.maps.places) {
		  return;
		}

		if (!addressInputRef.current) {
		  return;
		}

		if (autocompleteRef.current) {
		  return;
		}

		try {
		  autocompleteRef.current = new window.google.maps.places.Autocomplete(
			addressInputRef.current,
			{
			  types: ['address'],
			  componentRestrictions: { country: 'us' },
			  fields: ['address_components', 'formatted_address', 'geometry', 'name', 'place_id']
			}
		  );

		  autocompleteRef.current.addListener('place_changed', () => {
			const place = autocompleteRef.current.getPlace();
			
			if (place.address_components) {
			  // Extract address components
			  let streetNumber = '';
			  let streetName = '';
			  let city = '';
			  let state = '';
			  let zipcode = '';
			  
			  place.address_components.forEach(component => {
				const types = component.types;
				
				if (types.includes('street_number')) {
				  streetNumber = component.long_name;
				}
				if (types.includes('route')) {
				  streetName = component.long_name;
				}
				if (types.includes('locality')) {
				  city = component.long_name;
				}
				if (types.includes('administrative_area_level_1')) {
				  state = component.short_name; // Use short_name for state abbreviation
				}
				if (types.includes('postal_code')) {
				  zipcode = component.long_name;
				}
			  });
			  
			  // Check if all required components are present
			  if (streetNumber && streetName && city && state && zipcode) {
				// Format address as: 123 STREET_NAME, CITY, STATE, ZIPCODE
				const formattedAddress = `${streetNumber} ${streetName}, ${city}, ${state}, ${zipcode}`;
				
				setProfileData(prev => ({
				  ...prev,
				  address: formattedAddress
				}));
				
				if (profileErrors.address) {
				  setProfileErrors(prev => ({
					...prev,
					address: ''
				  }));
				}
			  } else {
				// Missing required components, clear the field and show error
				setProfileData(prev => ({
				  ...prev,
				  address: ''
				}));
				setProfileErrors(prev => ({
				  ...prev,
				  address: 'Provide Valid address'
				}));
			  }
			}
		  });
		} catch (error) {
		  // Silent error handling
		}
	  };

	  // Function to go back to profile step
	  const handleBackToProfile = () => {
		setCurrentStep(1);
	  };

	 

	  const handleQuestionChange = (index, value) => {
		const newQuestions = [...questions];
		newQuestions[index].question = value;
		setQuestions(newQuestions);
	  };
	
	  const handleAnswerChange = (index, value) => {
		const newQuestions = [...questions];
		newQuestions[index].answer = value;
		setQuestions(newQuestions);
	  };
	
	  const isFormValid = () => {
		const allQuestionsAnswered = questions.every((q) => q.question && q.answer);
		return allQuestionsAnswered && acknowledged;
	  };

	  const validateForm = () => {
		const newErrors = questions.map((q) => ({
		  questionError: !q.question ? "Please select a question." : "",
		  answerError: !q.answer ? "Please provide an answer." : ""
		}));
		setErrors(newErrors);
		const allQuestionsAnswered = newErrors.every((error) => !error.questionError && !error.answerError);
		return allQuestionsAnswered && acknowledged;
	  };
	
	  const handleSubmit =async (e) => {
		e.preventDefault();
		if (!validateForm()) {
			return; 
		  }
		
		setIsSubmittingQuestions(true);
		
		try {
			const formData = new FormData();
		
			questions.forEach((q, index) => {
			  formData.append(`question${index + 1}`, q.question);
			  formData.append(`answer${index + 1}`, q.answer);
			});
			const token = sessionStorage.getItem('token');
			const userId = sessionStorage.getItem('user_id');
			const response =await storeSecurityQuestions(token,formData,userId);
			if(response.data === true){
				navigate("/course/home");
			}
		} catch (error) {
			console.error('Error submitting security questions:', error);
		} finally {
			setIsSubmittingQuestions(false);
		}
	  };

	  const getSelectedQuestions = () => {
		return questions.map((q) => q.question).filter(Boolean);
	  };
	

	return(
		<div className="container  min-vh-100 mt-4">
        <div className="row  mt-4">
          	<div class="col-lg-7 ps-lg-5 mt-4">
				{/* Stepper Progress */}
				<div className="step-container mb-4">
					<div className={`step ${currentStep >= 1 ? 'active' : ''}`}>
						<span className="step-number">1</span>
						<span className="step-label">Profile Information</span>
					</div>
					<div className={`step ${currentStep >= 2 ? 'active' : ''}`}>
						<span className="step-number">2</span>
						<span className="step-label">Security Questions</span>
					</div>
				</div>

				{/* Step 1: Profile Information */}
				{currentStep === 1 && (
					<>
						<h7 class="fw-bold display-5 mt-4">Complete Your Profile Information</h7>
						<p class="d-block line-h-150 pt-4">Please provide your personal details to continue with the registration process.</p>
						
						{profileErrors.general && <div className="alert alert-danger">{profileErrors.general}</div>}
						
						
						
						<form onSubmit={handleProfileSubmit}>
							<div className="row">
								<div className="col-md-6">
									<div className="form-floating mb-3">
										<input 
											type="text" 
											className="form-control" 
											id="first_name" 
											placeholder=" " 
											name="first_name" 
											value={profileData.first_name} 
											onChange={handleProfileChange}
										/>
										<label htmlFor="first_name">First Name</label>
										{profileErrors.first_name && <div className="text-danger mt-1">{profileErrors.first_name}</div>}
									</div>
								</div>
								<div className="col-md-6">
									<div className="form-floating mb-3">
										<input 
											type="text" 
											className="form-control" 
											id="last_name" 
											placeholder=" " 
											name="last_name" 
											value={profileData.last_name} 
											onChange={handleProfileChange}
										/>
										<label htmlFor="last_name">Last Name</label>
										{profileErrors.last_name && <div className="text-danger mt-1">{profileErrors.last_name}</div>}
									</div>
								</div>
								<div className="col-12">
									<div className="form-floating mb-3">
										<input 
											ref={addressInputRef}
											type="text" 
											className={`form-control ${profileErrors.address ? 'is-invalid' : ''}`} 
											id="address" 
											placeholder=" " 
											name="address" 
											value={profileData.address} 
											onChange={handleProfileChange}
											autoComplete="off"
											onFocus={() => {
												if (isGoogleMapsLoaded && !autocompleteRef.current) {
													setTimeout(() => {
														initializeAutocomplete();
													}, 50);
												}
											}}
										/>
										<label htmlFor="address">Address</label>
										{profileErrors.address && <div className="text-danger mt-1">{profileErrors.address}</div>}
									</div>
								</div>
								<div className="col-12">
									<div className="d-flex gap-2">
										<button 
											type="submit" 
											className="btn btn-primary-s mt-3"
											disabled={isLoading}
										>
											{isLoading ? 'Processing...' : 'Update Profile & Continue'}
										</button>
										{sessionStorage.getItem('user_name')?.trim() !== "null" && (
											<button 
												type="button" 
												className="btn btn-success mt-3"
												onClick={() => setCurrentStep(2)}
											>
												Continue to Security Questions
											</button>
										)}
									</div>
								</div>
							</div>
						</form>
					</>
				)}

				{/* Step 2: Security Questions */}
				{currentStep === 2 && (
					<>
						<div className="d-flex justify-content-between align-items-center mb-3">
							<div>
								<h7 class="fw-bold display-5 mt-4">Select three questions and provide answers for verification.</h7>
								<p class="d-block line-h-150 pt-4">These questions may be randomly asked while you are taking this Course to validate that it is you who is taking the test.</p>
							</div>
						</div>
						
						{/* Warning Section */}
						<div className="alert alert-warning border-warning mb-4" style={{ backgroundColor: '#fff3cd', borderColor: '#ffc107', borderRadius: '8px' }}>
							<div className="d-flex align-items-start">
								<i className="fa fa-exclamation-triangle me-3 mt-1" style={{ color: '#dc3545', fontSize: '1.5rem' }}></i>
								<div className="flex-grow-1">
									<h6 className="fw-bold mb-2" style={{ color: '#dc3545' }}>Important Security Question Information</h6>
									<p className="mb-2" style={{ color: '#dc3545', marginBottom: '0.5rem' }}>
										When presented with a security question you will have <strong>45 seconds</strong> to answer.
									</p>
									<p className="mb-3 fw-bold" style={{ color: '#dc3545', fontSize: '1rem' }}>
										Failure to answer will result in course failure and the course fee will not be refunded.
									</p>
									
									{/* Acknowledgment Checkbox */}
									<div className="form-check mt-3 pt-3" style={{ borderTop: '1px solid rgba(220, 53, 69, 0.2)' }}>
										<input
											className="form-check-input"
											type="checkbox"
											id="acknowledgment"
											checked={acknowledged}
											onChange={(e) => setAcknowledged(e.target.checked)}
											style={{ width: '1.25rem', height: '1.25rem', marginTop: '0.25rem' }}
										/>
										<label className="form-check-label ms-3" htmlFor="acknowledgment" style={{ fontSize: '1rem', lineHeight: '1.6', cursor: 'pointer', color: '#dc3545' }}>
											<strong>I understand</strong> that failure to answer a security question within the prescribed time will result in course failure and forfeiture of the course fee.
										</label>
									</div>
								</div>
							</div>
						</div>
						<form onSubmit={handleSubmit}>
							{questions.map((q, index) => {
							const selectedQuestions = getSelectedQuestions();
							return (
								<div className="mb-3 mt-4" key={index}>
								<label className="form-label">Security Question {index + 1}</label>
								<select
									className="form-select"
									value={q.question}
									onChange={(e) => handleQuestionChange(index, e.target.value)}
									required
									disabled={!acknowledged}
								>
									<option value="" disabled>
									Select a question...
									</option>
									{securityquestions
									.filter(
										(question) =>
										!selectedQuestions.includes(question.question) ||
										question.question === q.question
									)
									.map((question, i) => (
										<option key={question.id} value={question.question}>
										{question.question}
										</option>
									))}
								</select>
								{errors[index]?.questionError && (
									<div className="text-danger mt-1">{errors[index].questionError}</div>
								)}
								<input
									type="text"
									className="form-control mt-2"
									placeholder="Your Answer"
									value={q.answer}
									onChange={(e) => handleAnswerChange(index, e.target.value)}
									required
									disabled={!acknowledged}
								/>
								{errors[index]?.answerError && (
									<div className="text-danger mt-1">{errors[index].answerError}</div>
								)}
								</div>
							);
							})}
						  <button 
							type="submit" 
							className="btn btn-primary-s mt-3"
							disabled={isSubmittingQuestions || !isFormValid()}
						>
							{isSubmittingQuestions ? (
								<>
									<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									Processing...
								</>
							) : (
								'Submit'
							)}
							</button>
						</form>
					</>
				)}
				
        	</div>
          <div className="col-md-5 col-lg-5 d-flex justify-content-start mt-4 d-none d-md-flex">
            <div className="mt-4">
              <img className="image-security" src={startnow} width={500} height={500}/>
            </div>
          </div>
        </div>
      
    </div>
	);
}
export default Securityquestion;